import { render, staticRenderFns } from "./Pick.vue?vue&type=template&id=33ff2a16&scoped=true"
import script from "./Pick.vue?vue&type=script&lang=js"
export * from "./Pick.vue?vue&type=script&lang=js"
import style0 from "./Pick.vue?vue&type=style&index=0&id=33ff2a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ff2a16",
  null
  
)

export default component.exports